import { collection, onSnapshot } from "firebase/firestore";
import mapSnapshot from "../common-functions/mapSnapshot";
import { db } from "../../firebase/firebase-utils";

export default function loadUsersRT(user, setUsers, setUnsubscribeUsers, setLoading) {
    try {
        setLoading(true);
        const collectionRef = collection(db, "users");
        const unsubscribe = onSnapshot(collectionRef, (snapshot) => {
            console.log("Updating users...");
            const users = mapSnapshot(snapshot);
            setUsers(users);
            setLoading(false);
        });
        setUnsubscribeUsers(() => () => unsubscribe());
    } catch (error) {
        console.log(error);
    }
}
